export const setUser = (user) => {
  localStorage.setItem('auth_user', JSON.stringify(user));
};

export const getUser = () => {
  try {
    return JSON.parse(localStorage.getItem('auth_user'));
  } catch {
    return null;
  }
};

export const isAuthenticated = () => {
  return !!getUser();
};

export const logout = () => {
  localStorage.removeItem('auth_user');
};
